import { useState } from "react";
import Header from "../components/header";
import Sidebar from "./sidebar";

function Layout({ children }: { children: React.ReactNode }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  return (
    <div className="flex h-full h-screen overflow-hidden bg-[#F8FAFC]">
      <div className="h-screen overflow-y-auto">
        <Sidebar
          toggleSidebar={toggleSidebar}
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
      </div>
      <div
        className="relative flex flex-1 flex-col overflow-y-auto"
        id="main-content"
      >
        <Header />
        {children}
      </div>
    </div>

    // <div className="bg-lightBg flex min-h-screen flex-col pb-[135px]">
    //   <Header />
    //   {children}
    // </div>
  );
}

export default Layout;
